module.exports = __webpack_public_path__ + "img/estrella_borde_negro.b7ae301e.svg";